import { httpWithAuth } from '~/clients';
import { USER_PROFILE } from '~/constants/endpoints';
import userProfile from './queries/userProfile';

type UserProfileResponse = {
  data: {
    userProfile: {
      profile: {
        customerId: string;
        email: string;
      };
    };
  };
};

export default function fetchUserProfile(controller: AbortController) {
  return httpWithAuth
    .post<UserProfileResponse>(
      USER_PROFILE,
      { query: userProfile },
      {
        headers: {
          'apollographql-client-name': process.env.npm_package_name ?? '',
          'apollographql-client-version': process.env.npm_package_version ?? ''
        },
        signal: controller.signal
      }
    )
    .then(res => res.data.data.userProfile.profile);
}
